
<template>
    <div class="page wallet">
        <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
        <pageTitle title='商城预存款明细' :showRight = 'true'  rightTitle='兑换' @rightHandler='goExchange' />
        <div class="mycoin">
            商城预存款
            <h2>￥{{walletInfo.MallCoin}}</h2>
        </div>
        <div class="demo-refresh-container">
            <div class="list">
                <div class="item" v-for="item in Records">
                    <div class="date">
                        {{item.OperateDate}}
                    </div>
                    <div>
                        <span class='strong'>{{item.TypeName}}</span><br/>
                        <span class='detail'>{{item.Remark}}</span>
                    </div>
                    <div>
                        <span class='num'>{{getAmount(item) | discount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <loadListTail mainTitle='您暂无明细记录' mainIcon='noDetail' :noMore='loadState.stop' :isLoading='loadState.loading' :overZero='Records.length > 0'  />
        <div class='loading' v-if='loadState.loading'>
            <img src="../../../static/LoadingBest.gif" />
        </div>
    </div>
</template>

<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import Scroll from '../../utils/loading'
import loadListTail from '../../components/loadListTail'

export default {
  data () {
    return {
        Records:[],
        loadState:'',
        scroll:null,
        refreshing: false,
        trigger: null,
        change:false
    }
  },
  components:{
    loadListTail
  },
  mounted(){
    this.trigger = this.$el
    this.scroll = Scroll.Create(this,this.getData,10,1)
  },
  activated(){
    this.scroll.addHandler()
  },
  deactivated(){
    this.scroll.removeHandler()
  },
  methods: {
    initData(){
        //清空显示数据
        this.Records = []
        //初始化本页控制数据、分页参数
        this.scroll.refresh()
    },
    getData () {
      var that = this
      var params = new this.URLSearchParam();
      params.append('pageIndex', this.pageParam.index);
      params.append('pageSize', 10);
      return new Promise(function(resolve, reject) {
        that.$http.post(api.getMallCoinLog(),params.toParam()).then((res) => {
            if(res.Result){
                var temp = res.Data;
                resolve(temp.length);
                that.Records =that.Records.concat(temp);
            }
            else{
                resolve(null);
                that.$router.push({ path: '/user/Login' })
            }
        })
      })
    },
    refresh () {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },
    getAmount(item){
      // 获取兑换数量
        // K币返回数量除以100
        if(item.Type == 1){
            return item.OriginalAmount/100
        }
        return item.Amount
    },
    goExchange(){
      this.$router.push({ path: '/wallet/mallDepositExchange' })
    }
  },
  computed:{
    ...mapGetters({
        walletInfo:'g_walletInfo',loginInfo:'g_loginInfo'
    })
  },
  watch:{ 
    loginInfo: {
        handler: function (val, oldVal) {
            this.initData()
        },
        deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// mallDeposit.vue?2ad4fa3a